import i18n from "i18next";

export const getCurrentLanguage = () => {
  const lang = i18n.resolvedLanguage || i18n.language || "en";
  return lang.substring(0, 2).toLowerCase();
};
